import NavBar, { type NavBarSection } from "src/layouts/SharedLayout/NavBar";
import { SideMenuLayout } from "src/layouts/SideMenuLayout/SideMenuLayout";
import { useSideMenuLayoutStyles } from "src/layouts/SideMenuLayout/SideMenuLayout.styles";

export function SideMenuAWithNavBarLayout({
    isAdmin = false,
    sections,
    children,
}: {
    isAdmin?: boolean;
    sections: NavBarSection[];
    children?: React.ReactNode;
}): JSX.Element {
    const classes = useSideMenuLayoutStyles();
    return (
        <SideMenuLayout sections={sections} isAdmin={isAdmin}>
            <NavBar className={classes.menu} sections={sections} />
            {children}
        </SideMenuLayout>
    );
}
